<ion-row>
  <ion-col class="padding-s center-text">
    <span class="center-text info-text-m text-color-primary">{{introLabel}}</span>
  </ion-col>
</ion-row>

<ion-row>
  <ion-col size="12">
    <date-input-selector [selector]="bookingDateSelector"></date-input-selector>
  </ion-col>
</ion-row>

<div class="margin-horizontal-m text-color-primary info-text-s text-left">{{bookingDateLabel}}</div>

<ion-row>
  <ion-col [size]="12">
    <ion-item class="transparent">
      <ion-label class="text-color-primary label-text-s ion-label-input">Contact Email</ion-label>
      <ion-input [(ngModel)]="bookingData.customerEmail" ngDefaultControl type="email" class="text-color info-text-m"
        [disabled]="false" placeholder="email@domain.com">
      </ion-input>
    </ion-item>
  </ion-col>
</ion-row>

<ion-row>
  <ion-col [size]="12">
    <ion-item class="transparent">
      <ion-label class="text-color-primary label-text-s ion-label-input">Contact Name</ion-label>
      <ion-input [(ngModel)]="bookingData.customerName" ngDefaultControl type="text" class="text-color info-text-m"
        [disabled]="false" placeholder="Your Name">
      </ion-input>
    </ion-item>
  </ion-col>
</ion-row>

<!-- <ion-row>
  <ion-col [size]="12">
    <ion-item class="transparent">
      <ion-label class="text-color-primary label-text-s ion-label-input">Contact Phone
        (optional)</ion-label>
      <ion-input [(ngModel)]="bookingData.customerPhone" ngDefaultControl type="tel" class="text-color info-text-m"
        [disabled]="false" placeholder="+XX xxxxxxxxx">
      </ion-input>
    </ion-item>
  </ion-col>
</ion-row> -->

<phone-number [tel]="bookingData.customerPhone" (valid)="checkPhoneValid($event)"
  (onType)="checkPhone($event)"></phone-number>

<div tappable class="margin-top-s margin-bottom-m">
  <span class="as-text element-selector button-font-size-s text-color-primary" (click)="openTerms()">
    {{privacyPolicyLabel}}
  </span>
</div>

<ion-row>
  <ion-col [size]="2" class="align-content">
    <ion-checkbox [(ngModel)]="consent.general" ngDefaultControl (ionChange)="onSelectAgreed($event)"
      class="custom-checkbox">
    </ion-checkbox>
  </ion-col>
  <ion-col [size]="10">
    <div class="text-color-primary info-text-s text-left">{{agreementLabel}}</div>
  </ion-col>
</ion-row>

<ion-row>
  <ion-col [size]="2" class="align-content">
    <ion-checkbox [(ngModel)]="consent.contact" ngDefaultControl class="custom-checkbox" [disabled]="!consent.general">
    </ion-checkbox>
  </ion-col>
  <ion-col [size]="10">
    <div class="text-color-primary info-text-s text-left">{{agreementContactLabel}}</div>
  </ion-col>
</ion-row>

<div class="margin-top-s margin-bottom-s info-text-s text-color-primary">
  {{agreementFooterLabel}}
</div>

<ion-row class="padding-horizontal-m">
  <ion-col [size]="12">

    <!-- <ion-button class="action-button-fill-large button-color-alternate" (click)="submitForm()"
      [disabled]="!consent.general">
      <ion-row class="full-w center-items">
        <ion-col size="4">
          <icon-wrapper [icon]="appIconsStandard.calendar" [custom]="false" [huge]="false">
          </icon-wrapper>
        </ion-col>
        <ion-col size="4">
          <span class="button-font-size-m padding-horizontal-s">{{submitLabel}}</span>
        </ion-col>
        <ion-col size="4">
          <div class="flex-col padding-left-s">
            <icon-wrapper [icon]="appIcons.play" [custom]="true" [huge]="false">
            </icon-wrapper>
          </div>
        </ion-col>
      </ion-row>
    </ion-button> -->

    <ion-button class="action-button-fill button-color-alternate" (click)="submitForm()" icon-end
      [disabled]="!consent.general">
      <span class="button-font-size-s">Get Free Pass*</span>
      <icon-wrapper slot="start" [icon]="appIconsStandard.calendar" [custom]="false" class="slot-icon-padding">
      </icon-wrapper>
    </ion-button>

  </ion-col>
</ion-row>

<ion-row>
  <ion-col class="padding-s center-text">
    <span class="center-text info-text-m text-color-primary">{{footerLabel}}</span>
  </ion-col>
</ion-row>